import colors from "./colors.module.scss"

type StyleType={
    main_color: string;
    main_color_light: string;
    caption: string;
    background: string;
    stroke: string;
    black: string;
    icon: string;
    white: string;
    discount: string;
    call_to_action: string;
    price: string;
    placeholder: string;
    red_1:string;
    red_2:string;
    gray_1:string;
    gray_2:string;
    gray_3:string;
    gray_4:string;
    gray_5:string;
    gray_6:string;
    gray_7:string;
    gray_8:string;
    gray_9:string;
    gray_10:string;
    gray_11:string;
    gray_12:string;
    gray_13:string;
    gray_14:string;
    gray_15:string;
    gray_16:string;

    blue_1:string;
    blue_2:string;
    blue_3:string;
    blue_4:string;
    blue_5:string;
    blue_6:string;
    blue_7:string;
    blue_8:string;
    blue_9:string;
    blue_10:string;
    blue_11:string;
    blue_12:string;
    blue_13:string;

    yellow_1:string;
    green_1:string;

}

const ColorSchema:StyleType={
    main_color: colors.main_color,
    main_color_light: colors.main_color_light,
    caption: colors.caption,
    background: colors.background,
    stroke: colors.stroke,
    black: colors.black,
    icon: colors.icon,
    white: colors.white,
    discount: colors.discount,
    call_to_action: colors.call_to_action,
    price: colors.price,
    placeholder: colors.placeholder,
    red_1:colors.red_1,
    red_2:colors.red_2,
    gray_1:colors.gray_1,
    gray_2:colors.gray_2,
    gray_3:colors.gray_3,
    gray_4:colors.gray_4,
    gray_5:colors.gray_5,
    gray_6:colors.gray_6,
    gray_7:colors.gray_7,
    gray_8:colors.gray_8,
    gray_9:colors.gray_9,
    gray_10:colors.gray_10,
    gray_11:colors.gray_11,
    gray_12:colors.gray_12,
    gray_13:colors.gray_13,
    gray_14:colors.gray_14,
    gray_15:colors.gray_15,
    gray_16:colors.gray_16,

    blue_1:colors.blue_1,
    blue_2:colors.blue_2,
    blue_3:colors.blue_3,
    blue_4:colors.blue_4,
    blue_5:colors.blue_5,
    blue_6:colors.blue_6,
    blue_7:colors.blue_7,
    blue_8:colors.blue_8,
    blue_9:colors.blue_9,
    blue_10:colors.blue_10,
    blue_11:colors.blue_11,
    blue_12:colors.blue_12,
    blue_13:colors.blue_13,


    yellow_1:colors.yellow_1,
    green_1:colors.green_1
}

export default ColorSchema;